import 'AppSrc/core/style/components/form/form-base-components/select-coordinator-form.css';
import { connect } from 'react-redux';
import { SelectCoordinatorForm } from 'AppSrc/core/components/forms/select-coordinator/select-coordinator-form';
import {
  isCrqEmergency,
  getIsInternationalCrq,
  getIsOlaCrq,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { setPeerReviewerGroupForEditCrqId, setPeerReviewerForEditCrqId } from 'AppSrc/core/actions/actions-edit-form';
import { getCoordinatorGroupByName } from 'AppSrc/core/coordinators/coordinator-groups-state-selectors';


const mapStateToProps = (state, ownProps) => {
  const { crqId, network } = ownProps;
  const formData = state.editForm.formDataById[crqId];
  const isEmergency = isCrqEmergency(formData);
  const isICM = getIsInternationalCrq(formData);
  const isOlo = getIsOlaCrq(formData);
  // the selected group should default to the coordinator group for the CRQ
  // if there is one
  const groupName = formData.peerReviewerGroup || formData.coordinatorGroup;
  const group = getCoordinatorGroupByName({
    state,
    network,
    groupName,
  });
  const groupId = group ? group.id : null;
  const coordinatorId = formData.peerReviewerId;

  // L3 approver/L3 approver group name required for Emergency Fixed and Mobile and for and rest all required Peer reviewer/peer group.
  const groupLabel = (isEmergency && !isOlo) ? 'L3 approver group' : 'peer group';
  const coordinatorLabel = (isEmergency && !isOlo) ? 'L3 Approver' : 'peer reviewer';

  // const groupLabel = 'peer group';
  // const coordinatorLabel = 'peer reviewer';
  // need to exclude logged in user as coordinator
  const excludeLoggedInCoordinator = true;
  return ({
    groupId,
    coordinatorId,
    groupLabel,
    coordinatorLabel,
    excludeLoggedInCoordinator,
    isEmergency,
    isICM,
    isOlo,
  });
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setGroup(group) {
    const { crqId } = ownProps;
    const groupName = group ? group.name : null;
    dispatch(setPeerReviewerGroupForEditCrqId({
      crqId,
      groupName,
    }));
  },
  setCoordinator(peerReviewer) {
    const { crqId } = ownProps;
    const { id } = peerReviewer;
    const name = peerReviewer.full_name;
    dispatch(setPeerReviewerForEditCrqId({
      crqId,
      id,
      name,
    }));
  },
});

const ViewCrqSelectPeerReviewer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectCoordinatorForm);

export { ViewCrqSelectPeerReviewer };
